import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useMsal} from '@azure/msal-react'
import {setFiltersOpen, setMsalToken, selectFiltersOpen, selectMsalToken} from '../slices/filtersSlice'

export const useFilters = () => {
  const dispatch = useDispatch()
  const {instance, accounts, inProgress} = useMsal()

  const filtersOpen = useSelector(selectFiltersOpen)
  const msalToken = useSelector(selectMsalToken)

  // Fetch MSAL token when authentication is ready
  useEffect(() => {
    if (accounts?.[0] && inProgress === 'none') {
      instance
        .acquireTokenSilent({
          account: accounts[0],
          scopes: [
            process.env.NODE_ENV === 'production' ? globalThis.__env?.REACT_APP_SCOPES : process.env.REACT_APP_SCOPES
          ]
        })
        .then((response) => {
          if (response?.accessToken) {
            dispatch(setMsalToken(response.accessToken))
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }, [inProgress, accounts, instance, dispatch])

  // Return the same API as the original provider
  return {
    msalToken,
    filtersOpen,
    setFiltersOpen: (value) => dispatch(setFiltersOpen(value))
  }
}
